export class Route {
  id: number;
  name: string;

  constructor(data) {
    Object.assign(this, data);
  }

}
